import { Suspense, lazy } from 'react';

import { Container } from '@hivebrite/design-system/Container';

import TopicCustomPageContainer from 'hb-react/shared/apps/Topics/containers/TopicCustomPageContainer';
import TopicEventsContainer from 'hb-react/shared/apps/Topics/containers/TopicEventsContainer';
import TopicForumContainer from 'hb-react/shared/apps/Topics/containers/TopicForumContainer';
import TopicHomeContainer from 'hb-react/shared/apps/Topics/containers/TopicHomeContainer';
import TopicJobsContainer from 'hb-react/shared/apps/Topics/containers/TopicJobsContainer';
import TopicLiveFeedContainer from 'hb-react/shared/apps/Topics/containers/TopicLiveFeedContainer';
import TopicMediaCenterContainer from 'hb-react/shared/apps/Topics/containers/TopicMediaCenterContainer';
import TopicMembersContainer from 'hb-react/shared/apps/Topics/containers/TopicMembersContainer';
import TopicMembershipsContainer from 'hb-react/shared/apps/Topics/containers/TopicMembershipsContainer';
import TopicMentoringContainer from 'hb-react/shared/apps/Topics/containers/TopicMentoringContainer';
import TopicNewsContainer from 'hb-react/shared/apps/Topics/containers/TopicNewsContainer';

const TopicVenturesContainerV2 = lazy(
  () => import('../../TopicVenturesContainerV2'),
);

const TopicVentures = ({ flags, ...otherProps }) => (
  <Suspense fallback={null}>
    <TopicVenturesContainerV2 {...otherProps} />
  </Suspense>
);

const TopicMediaCenter = ({ flags, ...otherProps }) => (
  <Suspense fallback={null}>
    <TopicMediaCenterContainer {...otherProps} />
  </Suspense>
);

export const topicRoutes = () =>
  [
    {
      component: TopicHomeContainer,
      path: '/',
    },
    {
      component: TopicHomeContainer,
      path: '/home',
    },
    {
      component: TopicLiveFeedContainer,
      path: '/feed',
    },
    {
      component: TopicMembersContainer,
      path: '/members',
    },
    {
      path: 'events/*',
      component: TopicEventsContainer,
    },
    {
      component: TopicNewsContainer,
      path: 'news/*',
    },
    {
      component: TopicMediaCenter,
      path: 'media_center/*',
    },
    {
      component: TopicVentures,
      path: 'ventures/*',
    },
    {
      component: TopicForumContainer,
      path: 'forum/*',
      Wrapper: Container,
    },
    {
      component: TopicMembershipsContainer,
      path: 'memberships/*',
    },
    {
      component: TopicCustomPageContainer,
      path: 'page/*',
    },
    {
      component: TopicMentoringContainer,
      path: 'mentoring/*',
    },
    {
      component: TopicJobsContainer,
      path: 'opportunities/*',
    },
  ].filter(Boolean);
